import type { DistanceBucket } from '@feral/shared/client'
import { imperial } from './prefs.js'

/**
 * Every distance the app shows, in the Units setting (WF-SET-10). One place, so a screen can't fall
 * back to the browser's language or to plain kilometers.
 */
const MI = 1609.344

/** FR-LOC-04: a bucket, never a number. */
export function formatDistance(b: DistanceBucket | null): string {
  if (b === null) return ''
  if (b === 'far') return imperial() ? '15+ mi' : '25+ km'
  if (!imperial()) return `< ${b} km`
  const mi = (b * 1000) / MI
  return `< ${mi < 1 ? mi.toFixed(1) : Math.round(mi)} mi`
}

/** An exact distance to a public place (spots are pinned exactly, FR-SPT-01). */
export function metres(m: number | null): string {
  if (m === null) return ''
  if (imperial()) {
    const mi = m / MI
    return mi < 0.2
      ? `${Math.round((m * 3.28084) / 10) * 10} ft`
      : `${mi < 10 ? mi.toFixed(1) : Math.round(mi)} mi`
  }
  return m < 1000 ? `${Math.round(m)} m` : `${(m / 1000).toFixed(m < 10_000 ? 1 : 0)} km`
}

/** A radius such as the Wall's 25 km or the Gate's 50 km, rounded the way people say it. */
export function radius(km: number): string {
  return imperial() ? `${Math.round(km / 1.609344)} mi` : `${km} km`
}

/** An approximate size, for the tile choices: "~560 ft", "~0.3 mi", "~460 m". */
export function about(m: number): string {
  if (!imperial()) return m < 1000 ? `~${m} m` : `~${(m / 1000).toFixed(1)} km`
  const mi = m / MI
  if (mi < 0.2) return `~${Math.round((m * 3.28084) / 10) * 10} ft`
  return `~${Number((Math.round(mi * 20) / 20).toFixed(2))} mi`
}
